import { Slower } from "./Slower";
export async function loadExternalSlowInteraction(engine, refresh = true) {
    await engine.addInteractor("externalSlow", (container) => new Slower(container), refresh);
}
export * from "./Options/Classes/Slow";
export * from "./Options/Interfaces/ISlow";
